import { Stack } from '@mui/material';
import { Icon } from '@mui/material';
import { StackProps } from '@mui/material';
import { Box } from '@mui/material';
import { SORT_DIRECTION } from '@schooly/api';
import { ArrowUpIcon } from '@schooly/style';
import { ArrowDownIcon } from '@schooly/style';

export type DataGridSortableCellProps<T> = {
  sortBy?: T;
  isSorted: boolean;
  sortDirection?: SORT_DIRECTION;
  onChangeSort?: (sortBy: T) => void;
} & StackProps;

export const DataGridSortableCell = <T extends string>({
  isSorted,
  sortBy,
  sortDirection,
  onChangeSort,
  children,
  ...props
}: DataGridSortableCellProps<T>) => {
  const renderSortArrow = () => {
    if (!isSorted) return null;

    const Arrow = sortDirection === SORT_DIRECTION.DESC ? ArrowDownIcon : ArrowUpIcon;

    return (
      <Icon sx={(theme) => ({ width: theme.spacing(2.5), mr: -2.5 })}>
        <Arrow />
      </Icon>
    );
  };

  return (
    <Stack
      position="relative"
      onClick={sortBy ? () => onChangeSort?.(sortBy) : undefined}
      height="100%"
      flexDirection="row"
      alignItems="center"
      sx={{ cursor: 'pointer' }}
      {...props}
    >
      <Box overflow="hidden">{children}</Box>
      {renderSortArrow()}
    </Stack>
  );
};
